<div class="header-container">
    <div class="border-round-left-md
                border-round-right-md
                w-full mt-5 lg:mt-1 xl:mt-1"
    [ngClass]="isDash ? '': 'header-entity'">
    <div>
      <app-top-nav></app-top-nav>
    </div>
    <div>
      <div>
                <div class="p-2 pb-1 h-auto
                            border-round-left-md
                            border-round-right-md
                            header-content
                            text-sm shadow-8">

          @if (!headerEntity) {
            <div class="w-full flex justify-content-between">
              <h1 class="text-base white-space-nowrap">{{title}}&nbsp;{{entityId}}</h1>
              @if (!headerEntity && serverNotificationCount() > 0) {
                <h1 id="vsmLink" class="text-base white-space-nowrap text-red-600" (click)="showNotifications()">View {{serverNotificationCount()}} important system message{{serverNotificationCount() > 1 ? "s" : ""}}</h1>
              }
            </div>
          }

          @if (headerEntity) {
            <div class="w-full flex justify-content-between -mt-2 gap-3">
              <div class="flex flex-column flex-auto overflow-hidden">
                <h1 class="text-lg mt-1 white-space-nowrap overflow-hidden text-overflow-ellipsis" >{{title}}&nbsp;{{entityId}}@if (entityName !== '') {
                  <span>&nbsp;-&nbsp;</span>
                }{{entityName}}</h1>
                <ul class="pl-0 mb-0 list-none">
                  <li>
                    @if (showMapItLink) {
                      <a (click)="goToLocation()" class="text-xs basic-link ml-2">
                        <img class="pr-1 -mb-1 h-1rem vertical-align-text-top" src="assets/icons/gmap_icon.png" alt="">{{'mapIt'| translate}}
                      </a>
                    }
                    @if (showPDFLink) {
                      <a (click)="downloadPDF()" class="text-xs basic-link">
                        <img class="pr-1 -mb-1 h-1rem vertical-align-text-top" src="assets/icons/pdf.png" alt="">{{'pdf'| translate}}
                      </a>
                    }
                    @if (showClientView) {
                      <a (click)="clientView()" class="text-xs basic-link ml-2">
                        <img class="pr-1 -mb-1 h-1rem vertical-align-text-top" src="assets/icons/cli_view.png" alt="">{{'clientView'| translate}}
                      </a>
                    }
                    @if (showQueryWithSignal) {
                      <a (click)="queryWithSignal()" class="text-xs basic-link ml-2">
                        <img class="pr-1 -mb-1 h-1rem vertical-align-text-top" src="assets/icons/signal_icon.svg" alt="">{{'queryWithSignal'| translate}}
                      </a>
                    }
                    @if (showAskUs) {
                      <a (click)="goAskUs()" class="text-xs basic-link ml-2"
                        [pTooltip]="'relatedAskUsTooltip'| translate: { openedCount: askUsQuestionStatus.openedCount, closedCount: askUsQuestionStatus.closedCount }">
                        <img class="pr-1 -mb-1 h-1rem vertical-align-text-top" 
                        [src]="askUsQuestionStatus.openedCount > 0 ? 'assets/icons/green-question.png' : 'assets/icons/red-question.png'"
                        >{{'relatedAskUs'| translate}}
                      </a>
                    }
                    @if (showCopyRecordLink) {
                      <a (click)="copyRecordLink()" class="text-xs basic-link ml-2">
                        <img class="pr-1 -mb-1 h-1rem vertical-align-text-top" src="assets/icons/clipboard-link.svg" alt="">{{'recordLinkCopy'| translate}}
                      </a>
                    }
                    @if (showCopyRecordConfirmation) {
                      <span class="text-xs ml-2 cursor-none">
                        <img class="pr-1 -mb-1 h-1rem vertical-align-text-top" src="assets/icons/clipboard-link.svg" alt="">{{'recordLinkCopied'| translate}}
                      </span>
                    }
                  </li>
                </ul>
              </div>
              <div class="flex flex-column mt-1 p-0 col-fixed">
                <div>
                  @if (tKeyExitRecordButtonTitle !== null && tKeyExitRecordButtonTitle !== '') {
                    <button
                      class="btn-record-exit border-round-left-md border-round-right-md border-none text-xs mr-1 xl:mr-4 lg:mr-4 md:mr-4 sm:mr-4 p-1 px-4 h-auto"
                      (click)="exitRecord()"
                    [disabled]="isExitButtonDisabled()">{{ tKeyExitRecordButtonTitle| translate }}</button>
                  }
                  @if (tKeySaveButtonTitle !== null && tKeySaveButtonTitle !== '') {
                    <button
                      class="btn-record-save border-round-left-md border-round-right-md border-none text-xs p-1 px-4 h-auto"
                      (click)="saveEntity()"
                    [disabled]="isSaveButtonDisabled()">{{ tKeySaveButtonTitle | translate }}</button>
                  }
                </div>
                @if (warningMsgLink.length > 0) {
                  <div class="text-center">
                    <label class="text-red-600 text-xs underline cursor-pointer" (click)="showWarningMsg()">{{ warningMsgLink }}</label>
                  </div>
                }
              </div>
            </div>
          }
          <div class="flex flex-column w-full text-center mt-1 mb-1">
            <div class="flex flex-column" >
              @if (headerService.cautionMessage !== '') {
                <div class="w-11 mb-1" >
                  <label class="text-xs font-bold text-red-600">{{headerService.cautionMessage}}</label>
                </div>
              }
              @if (lockError?.length > 0) {
                <div class="mb-1 white-space-normal">
                  <label class="text-xs font-bold text-red-600">{{lockMessageStart}}</label>
                  @if (lockUserLink!=='') {
                    <a (click)="openUserModal(lockUserLink)" class="font-bold text-blue-600 cursor-pointer text-xs">{{lockUserLink}}</a>
                  }
                  @if (lockMessageEnd!=='') {
                    <label class="text-xs font-bold text-red-600">{{lockMessageEnd}}</label>
                  }
                  <button class="btn-record-reload border-round-left-md border-round-right-md border-none text-xs w-8rem text-center ml-4" (click)="editRecord()">{{'common.editRecord'| translate}}</button>
                </div>
              }
              @if (headerEntity && headerService.changeForm) {
                <div  class="flex flex-column justify-content-center mb-1">
                  <div>
                    <label class="text-xs text-red-600 font-bold">{{isNewEntity ? changedMessageNewEnity : changedMessage}}</label>
                    @if (!isNewEntity) {
                      <button
                      class="btn-record-reload border-round-left-md border-round-right-md border-none text-xs w-4rem text-center ml-4" (click)="discardChanges()">{{'discard'| translate}}</button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
